import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/socialEnabled.ts
import { Exception } from "@wbk/logger";
var getSocialEnabled = (_0) => __async(null, [_0], function* ({ country, platform }) {
  var _a, _b;
  try {
    const params = new URLSearchParams({ country, platform });
    const data = yield fetchClient({
      url: `/auth/social/enabled?${params.toString()}`,
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSocialEnabledException"
    });
  }
});

export {
  getSocialEnabled
};
//# sourceMappingURL=chunk-BPQFN7XB.mjs.map